import { http, HttpResponse } from "msw";
import mockCardDetails from "../data/cardDetails";
const handler = http.get("/api/admin/card-details/:id", ()=>{
    return HttpResponse.json(mockCardDetails);
});
export default handler;
